<template>
  <div>
    <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-position="top"
        size="medium"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item
              label="Tên cơ chế lương"
              prop="name"
              class="font-weight-bold"
          >
            <el-input
                v-model="form.name"
                placeholder="Nhập tên cơ chế lương..."
                clearable
            />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
              label="Loại khu vực"
              prop="area_type_ids"
              class="font-weight-bold"
          >
            <el-select
                v-model="form.area_type_ids"
                class="w-100"
                multiple
                clearable
                placeholder="Chọn loại khu vực"
                @change="handleAreaTypeChange"
            >
              <el-option
                  v-for="item in areaTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
              label="Khu vực áp dụng"
              prop="area_ids"
              class="font-weight-bold"
          >
            <el-select
                v-model="form.area_ids"
                class="w-100"
                multiple
                filterable
                clearable
                collapse-tags
                :disabled="!form.area_type_ids.length"
                placeholder="Chọn khu vực áp dụng..."
            >
              <el-option
                  v-for="item in filteredAreas"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
              label="Loại ứng viên"
              prop="candidate_type_ids"
              class="font-weight-bold"
          >
            <el-select
                v-model="form.candidate_type_ids"
                class="w-100"
                multiple
                clearable
                placeholder="Chọn loại ứng viên..."
            >
              <el-option
                  v-for="item in candidateTypes"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item
              label="Văn phòng áp dụng"
              prop="branch_ids"
              class="font-weight-bold"
          >
            <el-select
                v-model="form.branch_ids"
                class="w-100"
                multiple
                filterable
                clearable
                collapse-tags
                placeholder="Chọn văn phòng áp dụng..."
            >
              <el-option
                  v-for="item in branches"
                  :key="item.id"
                  :label="item.name_alias || item.name"
                  :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div class="d-flex justify-content-end border-top pt-4 mt-4">
      <button
          type="button"
          class="btn btn-secondary font-weight-bold px-6 mr-3"
          @click="$emit('cancel')"
      >
        Hủy
      </button>

      <button
          type="button"
          class="btn btn-primary font-weight-bolder px-6 d-inline-flex align-items-center"
          :disabled="loading"
          @click="handleSave"
      >
        <i class="el-icon-loading mr-1 font-size-base" v-if="loading"></i>
        <i class="el-icon-check mr-1 font-size-base" v-else></i>
        Lưu
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "DialogCreateOrEditSalaryMechanism",

  props: {
    salaryMechanism: {
      type: Object,
      default: null
    },

    areas: {
      type: Array,
      default: () => []
    },

    branches: {
      type: Array,
      default: () => []
    },

    candidateTypes: {
      type: Array,
      default: () => []
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      form: this.defaultForm(),

      areaTypes: [
        { id: 1, name: "Trung tâm" },
        { id: 2, name: "Tỉnh" }
      ],

      rules: {
        name: [
          {
            required: true,
            message: "Vui lòng nhập tên cơ chế lương",
            trigger: "blur"
          }
        ],

        area_type_ids: [
          {
            required: true,
            message: "Vui lòng chọn loại khu vực",
            trigger: "change"
          }
        ],

        area_ids: [
          {
            required: true,
            message: "Vui lòng chọn khu vực áp dụng",
            trigger: "change"
          }
        ],

        candidate_type_ids: [
          {
            required: true,
            message: "Vui lòng chọn loại ứng viên",
            trigger: "change"
          }
        ]
      }
    };
  },

  computed: {
    filteredAreas() {
      if (!this.form.area_type_ids.length) {
        return [];
      }

      return this.areas.filter(area =>
          this.form.area_type_ids.includes(Number(area.type_id))
      );
    }
  },

  watch: {
    salaryMechanism: {
      immediate: true,

      handler(value) {
        this.form = value
            ? {
              ...this.defaultForm(),
              ...value
            }
            : this.defaultForm();

        this.$nextTick(() => {
          this.$refs.form?.clearValidate();
        });
      }
    }
  },

  methods: {
    defaultForm() {
      return {
        id: null,
        name: "",
        area_type_ids: [],
        area_ids: [],
        candidate_type_ids: [],
        branch_ids: []
      };
    },

    handleAreaTypeChange() {
      const validAreaIds = this.filteredAreas.map(item => item.id);
      this.form.area_ids = this.form.area_ids.filter(id =>
          validAreaIds.includes(id)
      );
    },

    handleSave() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.$emit("save", {
          ...this.form
        });
      });
    }
  }
};
</script>